import React from 'react';
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const CtrChart = ({ data }) => {
  if (!data || !data.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>CTR Trend</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <RechartsLineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="date" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 12 }} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 12 }} tickFormatter={(value) => `${value}%`} />
            <Tooltip 
              contentStyle={{ backgroundColor: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: '8px' }}
              formatter={(value) => `${value?.toFixed(2) || 0}%`}
            />
            <Legend />
            <Line type="monotone" dataKey="ctr" stroke="#f59e0b" strokeWidth={2} name="CTR" dot={{ r: 4 }} activeDot={{ r: 6 }} />
            <Line type="monotone" dataKey="moving_average" stroke="#8b5cf6" strokeWidth={2} strokeDasharray="5 5" name="Moving Average" dot={false} />
          </RechartsLineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default CtrChart;
